import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col-12" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_5 = {
  key: 0,
  class: "p-formgrid p-grid p-col-12"
}
const _hoisted_6 = { class: "p-field p-col-4" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = {
  for: "ckanSkipRows",
  class: "kn-material-input-label"
}
const _hoisted_9 = { class: "p-field p-col-4" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = {
  for: "ckanLimitRows",
  class: "kn-material-input-label"
}
const _hoisted_12 = { class: "p-field p-col-4" }
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = {
  for: "ckanXslSheetNumber",
  class: "kn-material-input-label"
}
const _hoisted_15 = {
  key: 1,
  class: "p-formgrid p-grid p-col-12"
}
const _hoisted_16 = { class: "p-field p-col-3" }
const _hoisted_17 = { class: "p-float-label" }
const _hoisted_18 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_19 = { class: "p-field p-col-3" }
const _hoisted_20 = { class: "p-float-label" }
const _hoisted_21 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_22 = { class: "p-field p-col-3" }
const _hoisted_23 = { class: "p-float-label" }
const _hoisted_24 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_25 = { class: "p-field p-col-3" }
const _hoisted_26 = { class: "p-float-label" }
const _hoisted_27 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_28 = {
  key: 2,
  class: "p-formgrid p-grid p-col-12"
}
const _hoisted_29 = { class: "p-field p-col-6" }
const _hoisted_30 = { class: "p-float-label" }
const _hoisted_31 = {
  for: "ckanId",
  class: "kn-material-input-label"
}
const _hoisted_32 = { class: "p-field p-col-6" }
const _hoisted_33 = { class: "p-float-label" }
const _hoisted_34 = {
  for: "ckanUrl",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-mt-3" }, {
    content: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_Dropdown, {
              id: "ckanFileType",
              class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.ckanFileType.$invalid && _ctx.v$.dataset.ckanFileType.$dirty
                            }],
              options: _ctx.availableFileTypes,
              optionLabel: "name",
              optionValue: "name",
              modelValue: _ctx.v$.dataset.ckanFileType.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.ckanFileType.$model = $event)),
              onBeforeShow: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.ckanFileType.$touch()))
            }, null, 8, ["options", "modelValue", "class"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('managers.datasetManagement.fileType')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            vComp: _ctx.v$.dataset.ckanFileType,
            additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.datasetManagement.fileType')
                        }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        (_ctx.dataset.ckanFileType == 'XLS')
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("span", _hoisted_7, [
                  _createVNode(_component_InputText, {
                    id: "ckanSkipRows",
                    class: "kn-material-input",
                    type: "number",
                    modelValue: _ctx.dataset.ckanSkipRows,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dataset.ckanSkipRows = $event)),
                    modelModifiers: { trim: true },
                    onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('touched')))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanSkipRows')), 1)
                ])
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("span", _hoisted_10, [
                  _createVNode(_component_InputText, {
                    id: "ckanLimitRows",
                    class: "kn-material-input",
                    type: "number",
                    modelValue: _ctx.dataset.ckanLimitRows,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dataset.ckanLimitRows = $event)),
                    modelModifiers: { trim: true },
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('touched')))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanLimitRows')), 1)
                ])
              ]),
              _createVNode("div", _hoisted_12, [
                _createVNode("span", _hoisted_13, [
                  _createVNode(_component_InputText, {
                    id: "ckanXslSheetNumber",
                    class: "kn-material-input",
                    type: "number",
                    modelValue: _ctx.dataset.ckanXslSheetNumber,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataset.ckanXslSheetNumber = $event)),
                    modelModifiers: { trim: true },
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('touched')))
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanXslSheetNumber')), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.dataset.ckanFileType == 'CSV')
          ? (_openBlock(), _createBlock("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _createVNode("span", _hoisted_17, [
                  _createVNode(_component_Dropdown, {
                    id: "ckanCsvDelimiter",
                    class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.dataset.ckanCsvDelimiter.$invalid && _ctx.v$.dataset.ckanCsvDelimiter.$dirty
                                }],
                    options: _ctx.csvDelimiterCharacterTypes,
                    optionLabel: "name",
                    optionValue: "name",
                    modelValue: _ctx.v$.dataset.ckanCsvDelimiter.$model,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.dataset.ckanCsvDelimiter.$model = $event)),
                    onBeforeShow: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.dataset.ckanCsvDelimiter.$touch()))
                  }, null, 8, ["options", "modelValue", "class"]),
                  _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanCsvDelimiter')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.dataset.ckanCsvDelimiter,
                  additionalTranslateParams: {
                                fieldName: _ctx.$t('managers.datasetManagement.ckanCsvDelimiter')
                            }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode("span", _hoisted_20, [
                  _createVNode(_component_Dropdown, {
                    id: "ckanCsvQuote",
                    class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.dataset.ckanCsvQuote.$invalid && _ctx.v$.dataset.ckanCsvQuote.$dirty
                                }],
                    options: _ctx.csvQuoteCharacterTypes,
                    optionLabel: "name",
                    optionValue: "name",
                    modelValue: _ctx.v$.dataset.ckanCsvQuote.$model,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.dataset.ckanCsvQuote.$model = $event)),
                    onBeforeShow: _cache[12] || (_cache[12] = ($event: any) => (_ctx.v$.dataset.ckanCsvQuote.$touch()))
                  }, null, 8, ["options", "modelValue", "class"]),
                  _createVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanCsvQuote')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.dataset.ckanCsvQuote,
                  additionalTranslateParams: {
                                fieldName: _ctx.$t('managers.datasetManagement.ckanCsvQuote')
                            }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("span", _hoisted_23, [
                  _createVNode(_component_Dropdown, {
                    id: "ckanCsvEncoding",
                    class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.dataset.ckanCsvEncoding.$invalid && _ctx.v$.dataset.ckanCsvEncoding.$dirty
                                }],
                    options: _ctx.csvEncodingTypes,
                    optionLabel: "name",
                    optionValue: "name",
                    modelValue: _ctx.v$.dataset.ckanCsvEncoding.$model,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.v$.dataset.ckanCsvEncoding.$model = $event)),
                    onBeforeShow: _cache[14] || (_cache[14] = ($event: any) => (_ctx.v$.dataset.ckanCsvEncoding.$touch()))
                  }, null, 8, ["options", "modelValue", "class"]),
                  _createVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanCsvEncoding')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.dataset.ckanCsvEncoding,
                  additionalTranslateParams: {
                                fieldName: _ctx.$t('managers.datasetManagement.ckanCsvEncoding')
                            }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_25, [
                _createVNode("span", _hoisted_26, [
                  _createVNode(_component_Dropdown, {
                    id: "ckanDateFormat",
                    class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.dataset.ckanDateFormat.$invalid && _ctx.v$.dataset.ckanDateFormat.$dirty
                                }],
                    options: _ctx.ckanDateFormat,
                    optionLabel: "name",
                    optionValue: "name",
                    modelValue: _ctx.v$.dataset.ckanDateFormat.$model,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.v$.dataset.ckanDateFormat.$model = $event)),
                    onBeforeShow: _cache[16] || (_cache[16] = ($event: any) => (_ctx.v$.dataset.ckanDateFormat.$touch()))
                  }, null, 8, ["options", "modelValue", "class"]),
                  _createVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanDateFormat')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.dataset.ckanDateFormat,
                  additionalTranslateParams: {
                                fieldName: _ctx.$t('managers.datasetManagement.ckanDateFormat')
                            }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.dataset.ckanFileType)
          ? (_openBlock(), _createBlock("div", _hoisted_28, [
              _createVNode("div", _hoisted_29, [
                _createVNode("span", _hoisted_30, [
                  _createVNode(_component_InputText, {
                    id: "ckanId",
                    class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.dataset.ckanId.$invalid && _ctx.v$.dataset.ckanId.$dirty
                                }],
                    modelValue: _ctx.v$.dataset.ckanId.$model,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.v$.dataset.ckanId.$model = $event)),
                    modelModifiers: { trim: true },
                    onBlur: _cache[18] || (_cache[18] = ($event: any) => (_ctx.v$.dataset.ckanId.$touch())),
                    onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('touched')))
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanId')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.dataset.ckanId,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.datasetManagement.ckanId') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_32, [
                _createVNode("span", _hoisted_33, [
                  _createVNode(_component_InputText, {
                    id: "ckanUrl",
                    class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.dataset.ckanUrl.$invalid && _ctx.v$.dataset.ckanUrl.$dirty
                                }],
                    modelValue: _ctx.v$.dataset.ckanUrl.$model,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.v$.dataset.ckanUrl.$model = $event)),
                    modelModifiers: { trim: true },
                    onBlur: _cache[21] || (_cache[21] = ($event: any) => (_ctx.v$.dataset.ckanUrl.$touch())),
                    onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('touched')))
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanUrl')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.dataset.ckanUrl,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.datasetManagement.ckanUrl') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}